import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useTranslations,
  useScreenWidth,
} from "examsbook-react-sdk/custom-hooks";
import CourseCard from "../components/Tabs/InternalCourse";
import TopicMaterialContainer from "../components/Tabs/TopicMaterialContainer";
import TabsLandingPage from "../components/Tabs/TabsLandingPage";
import NotificationBar from "../components/common/Header/NotificationBar";
import {
  Box,
  Breadcrumbs,
  Card,
  CardContent,
  Paper,
  Typography,
  Tooltip,
  Button,
  useMediaQuery,
  Menu,
  MenuItem,
  ListItemIcon,
  IconButton,
  Link
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { useLocation } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { ReactComponent as SelfLearning } from "../../../web-app/src/assets/images/new-self.svg";
import { ReactComponent as Live } from "../assets/images/new-live.svg";
import { ReactComponent as MockTest } from "../../../web-app/src/assets/images/new-eval-test.svg";
import { ReactComponent as Certificate } from "../../../web-app/src/assets/images/new-certify.svg";
import { ReactComponent as StarVector1 } from "../../../web-app/src/assets/images/star-vector1.svg";
import { ReactComponent as StarVector2 } from "../../../web-app/src/assets/images/star-vector2.svg";
import { ReactComponent as StarVector3 } from "../../../web-app/src/assets/images/star-vector3.svg";
import ".././components/common/Header/Header.scss";
import { ReactComponent as TestUnlockedIcon } from "../assets/images/test-unlocked.svg";
import { ReactComponent as CourseCompletedIcon } from "../assets/images/course-completed.svg";
import { ReactComponent as PracticeQuizCompletedIcon } from "../assets/images/courseSuccess.svg";
import { ReactComponent as PlatinumBadge } from "../assets/images/platinumBadge.svg";
import { ReactComponent as GoldBadge } from "../assets/images/goldBadge.svg";
import { ReactComponent as BronzeBadge } from "../assets/images/bronzeBadge.svg";
import { ReactComponent as PointsIcon } from "../assets/images/pointsIcon.svg";
import { ReactComponent as LevelUpIcon } from "../assets/images/levelUpIcon.svg";
import ActiveSelfLearn from "../assets/images/Group.png";
import ActiveLiveClass from "../assets/images/LiveclassImg.png";
import ActiveMockTest from "../assets/images/MockText.png";
import ActiveCertificate from "../assets/images/ActiveCertificate.png";
import {
  recentCourseListAction,
  selfLearningVideoUrl,
  toggleBottomBar,
} from "examsbook-react-sdk/actions";
import { getSelfLearningAction, setDataId } from "examsbook-react-sdk/actions/getSelfLearningAction";
import SelfLearningCard, { LinearProgressCircular, LinearProgressWithLabel } from "../components/Tabs/SelfLearningCard";
import { useTheme } from "../constants/themeProvider";
import { useTheme as useMuiTheme } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { getProgressBarDetails } from "examsbook-react-sdk/actions/getSelfLearningAction";
import { ColorsConstant } from "../constants/colorConstant";
import { courseAddedNotification } from "examsbook-react-sdk/actions/getNotifications";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CloseIcon from '@material-ui/icons/Close';
import KeyboardArrowLeftSharp from '@material-ui/icons/KeyboardArrowLeftSharp';
import { ReactComponent as QuizIcon } from "../assets/images/quiz.svg";
import { ReactComponent as PDFIcon } from "../assets/images/test.svg";
import { ReactComponent as VideoIcon } from "../assets/images/video.svg";
import { ReactComponent as TextIcon } from "../assets/images/textIcon.svg"
import { ReactComponent as GreenTick } from "../assets/images/greenTick.svg";
import { setCourseName, setCourseProgress, setShowEvaluationTestAction, setShowInstructionsAction } from "examsbook-react-sdk/actions/getCourses";
import CommonButton from "../constants/CommonButton";
import BadgeSharePopover from "../components/common/BadgeSharePopover";

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: "none",
    zIndex: "auto",
    "& div": {
      "& div": {
        "& span": {
          "&.PrivateTabIndicator-colorPrimary-34": {
            backgroundColor: "#fff !important",
          },
        },
      },
    },
  },
  card: {
    "@media (max-width: 767px)": {
      paddingLeft: "0 !important",
      height: "inherit !important",
    },
  },
  fragment: {
    overflowX: "hidden",
    "@media (max-width: 767px)": {
      width: "100%",
      margin: 0,
    },
  },
  sectionNextBtn: {
    backgroundColor: ColorsConstant.defaultBlue,
    textTransform: "capitalize",
    padding: "4px 35px",
    border: "1px solid transparent",
    "&:hover": {
      backgroundColor: ColorsConstant.defaultBlue,
    },
  },
  cardClass: {
    background: ColorsConstant.notifyNavBg,
    paddingBottom: 0,
    height: 'inherit'
  },
  sectionPrevBtn: {
    backgroundColor: ColorsConstant.defaultBlue,
    textTransform: "capitalize",
    padding: "4px 20px",
    border: `1px solid ${ColorsConstant.defaultBlue}`,
    backgroundColor: "transparent",
    color: ColorsConstant.defaultBlue,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  sectionButtons: {
    display: 'none',
    justifyContent: "space-between",
    alignItems: "center",
    right: 0,
    bottom: 0,
    position: "absolute",
    left: 0,
    "@media (max-width: 960px)": {
      position: "fixed",
      padding: "20px",
      background: ColorsConstant.white,
      boxShadow: `0px -2px 12px 0px ${ColorsConstant.boxShadowColor}`,
      zIndex: 9999,
    },
  },
  mainFragmentExpand: {},
  cardExpand: {
    "@media (min-width: 960px) and (max-width: 1000px)": {
      width: "calc(371px - 7px)",
    },
    "@media (min-width: 1001px) and (max-width: 1023px)": {
      width: "calc(391px - 7px)",
    },
  },
  cardContentClass: {
    padding: "0px",
    // height: "calc(100svh - 160px)",
    height: 'inherit',
    overflow: "auto",
    "@media (max-width: 959px)": {
      marginBottom: "30px",
    },
  },
  activeIcon: {
    height: "30px",
    width: "35px",
  },
  heading: {
    display: "flex",
    alignItems: "center",
    flex: '1 1 auto',
    width: 'auto',
    minWidth: 0,
    fontWeight: 500,
    "& nav": {
      width: "100%",
      "& ol": {
        flexWrap: "initial",
        width: '100%',
        fontWeight: 500,
        fontSize: '22px',
        "& li": {
          whiteSpace: "nowrap",
          maxWidth: '40%',
          color: ColorsConstant.descriptionColor,
          "& .MuiButtonBase-root": {
            "&:hover": {
              backgroundColor: "transparent",
            },
          },
          span: {
            color: "rgba(0,0,0,0.87) !important",
          },
        },
      },
    },
    "& ol.MuiBreadcrumbs-ol li.MuiBreadcrumbs-separator:nth-last-of-type(2)": {
      display: "none !important",
    },
  },
  courseProgressAlign: {
    margin: "10px 0px",
    "& > div": {
      backgroundColor: "#ffffff !important",
    },
  },
  percentageColor: {
    color: "#ffffff !important",
    fontSize: "14px",
    fontWeight: "500",
  },
  "@media (max-width: 768px )": {
    heading: {
      fontSize: "16px",
      padding: "0",
    },
  },
  mainLeftContainer: {
    position: "relative",
    height: 'calc(100vh - 80px)',
    scrollMarginTop: "80px",
    overflowY: 'auto',
    "@media (max-width: 900px)": {
      height: "auto",
      marginBottom: "10px",
    },
  },
  ellipsisText: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "#fff",
  },
  moduleContentContainer: {
    minHeight: 'calc(80svh - 0px)',
    borderLeft: '1px solid #75768009',
    borderRight: '1px solid #75768009',
    borderRadius: '8px',
    overflowY: "auto",
    height: 'calc(100vh - 60px)',
    paddingBottom: '90px',
    margin: ' 0px 14px',
    "@media (max-width: 767px)": {
      height: "inherit",
    },
  },
  sidebarContainer: {
    transition: "width 0.3s ease, opacity 0.3s ease",
    overflow: "hidden",
    backgroundColor: "#fff",
  },

  "@keyframes slideInFromRight": {
    from: { transform: "translateX(100%)", opacity: 0.5 },
    to: { transform: "translateX(0)", opacity: 1 },
  },
  "@keyframes slideOutToRight": {
   from: { transform: "translateX(0)", opacity: 1 },
    to: { transform: "translateX(100%)", opacity: 0 },
},

  slideInAnim: {
    animation: "$slideInFromRight 0.5s ease-in-out forwards",
  },
  slideOutAnim: {
    animation: "$slideOutToRight 0.5s ease forwards",
  },
  breadcrumbsText: {
    fontSize: '18px',
    paddingRight: "5px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  },
  arrowButtonHeader: {
    display: "flex", alignItems: "center", gap: "8px"
  },
  mobileSectionNameDropdown: {
    display: "flex", alignItems: "center"
  },
  courseProgressLayout: {
    position: 'absolute', right: '24px', fontWeight: 500
  },
  rightSidebarMainDiv: {
    height: '100%', width: '60px', background: 'white', borderLeft: '1px solid #75768029', position: 'fixed', right: '0px', top: '60px'
  },
  rightSidebarToggleIcon: {
    display: 'flex', borderBottom: '1px solid #75768029', margin: '20px 12px', paddingBottom: '10px', cursor: 'pointer'
  },
  selfLearningBox: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 10px 20px 10px', borderBottom: '1px solid #75768029', margin: "0px 0px 8px 14px"
  },
  selfLearningText: {
    padding: "13px 0px 0px", fontSize: '16px', fontWeight: '500'
  },
  modalBg: {
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: '999999',
    position: 'fixed',
    background: '#00000080'
  },
  modalContent: {
    backgroundColor: '#fff',
    position: 'absolute',
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: '16px',
    borderRadius: '25px',
    width: '500px',
    '@media (max-width:900px)': {
      width: '350px',
    },
    '@media (max-width:439px)': {
      width: '320px',
    }
  },
  headingModal: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    borderRadius: "25px",
    padding: '40px 50px',
    '@media (max-width:439px)': {
      padding:'30px',
    }
  },
  icon: {
    '@media (max-width:900px)': {
      width: '48px',
      height: '48px',
    },
    '@media (max-width:439px)': {
      width: '34px',
      height: '34px',
    }
  },
  modalHeading: {
    textAlign: 'center',
    fontWeight: 600,
    color: '#000000',
    fontSize: '20px',
    marginTop: '30px',
    '@media (max-width:900px)': {
      marginTop: '20px',
    },
    '@media (max-width:439px)': {
      fontSize: '14px',
      marginTop: '10px',
    }
  },
  modalSubtext: {
    textAlign: 'center',
    fontWeight: '400',
    color: '#374151',
    fontSize: '14px',
    marginTop: '20px',
    display: 'block',
    '@media (max-width:439px)': {
      fontSize: '11px',
      marginTop: '10px',
    }
  },
  headingModalGamification: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    borderRadius: "25px",
    padding: '40px 50px',
    '@media (max-width:900px)': {
      padding:'20px 30px',
    }
  },
modalHeadingGamification: {
    textAlign: 'center',
    fontWeight: 600,
    color: '#000000',
    fontSize: '20px',
    marginTop: '30px',
    '@media (max-width:900px)': {
      marginTop: '10px',
    },
    '@media (max-width:439px)': {
      fontSize: '14px',
    }
  },
  modalSubtextGamification: {
    textAlign: 'center',
    fontWeight: '400',
    color: '#374151',
    fontSize: '14px',
    marginTop: '20px',
    '@media (max-width:900px)': {
      fontSize: '12px',
      marginTop: '10px',
    },
    '@media (max-width:439px)': {
      fontSize: '11px',
    }
  },
  okBtnGamification: {
        fontWeight: '500',
        borderRadius: '8px',
        color: 'white',
        cursor: 'pointer',
        textTransform: 'capitalize',
        backgroundColor: '#0C3450',
        '&:hover': {
            backgroundColor: '#0C3450 !important',
        },
        fontSize: "12px",
        marginTop: '20px',
        padding: "10px 30px",
        '@media (max-width:900px)': {
          fontSize: "11px",
          padding: "8px 20px",
        },
        '@media (max-width:439px)': {
          marginTop: '10px',
        }
    },
  statsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '30px',
    gap: '25px',
    width: '100%',
    '@media (max-width:439px)': {
      gap: '12px',
      marginTop: '20px',
    }
  },
  statGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  statBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: '1px solid #DBDBDB',
    borderRadius: '6px',
    padding: '10px',
    minWidth: '80px',
    '@media (max-width:439px)': {
      width: '55px',
      padding: '5px',
    }
  },
  statIcon: {
    width: '38px',
    height: '38px',
    '@media (max-width:439px)': {
      width: '25px',
      height: '25px',
    }
  },
  statValue: {
    marginTop: '8px',
    fontSize: '12px',
    fontWeight: 500,
    textAlign: 'center',
    color: '#000000',
    '@media (max-width:439px)': {
      fontSize: '6px',
    }
  },
  statLabel: {
    fontSize: '13px',
    fontWeight: 400,
    color: '#000000',
    marginTop: '10px',
    '@media (max-width:439px)': {
      fontSize: '8px',
    }
  },
  okBtn: {
    fontWeight: "500",
    borderRadius: "8px",
    color: "white",
    cursor: "pointer",
    textTransform: 'capitalize',
    backgroundColor: "#0C3450",
    "&:hover": {
      backgroundColor: "#0C3450 !important",
    },
    fontSize: "12px",
    marginTop: '30px',
    padding: "10px 30px",
    '@media (max-width:900px)': {
      marginTop: '20px',
    },
    '@media (max-width:439px)': {
      fontSize: '11px',
      marginTop: '15px',
      padding: "8px 20px",
    }
  },
  goToCoursesLink: {
    color: '#0C3450',
    fontWeight: 600,
    fontSize: '12px',
    marginTop: '20px',
    '@media (max-width:439px)': {
      fontSize: '11px',
      marginTop: '10px',
    }
  },
  goToCoursesLinkGamification: {
    color: '#0C3450',
    fontWeight: 600,
    fontSize: '12px',
    marginTop: '20px',
    '@media (max-width:900px)': {
      fontSize: '10px',
      marginTop: '10px',
    },
    '@media (max-width:439px)': {
      fontSize: '11px',
    }
  },
  starVectorBox: {
    display: 'flex',
    position: 'fixed',
    top: '20px',
    right: '30px',
  },
  starVector1: {
    marginTop: '10px',
    zIndex: 1,
    marginRight: '-8px'
  },
  starVector2: {
    marginTop: "12px"
  },
  starVector3: {
    marginLeft: "10px"
  }
}));

/**
 * Topic Material Tab-screen
 * @returns {*}
 * @constructor
 */

function TopicMaterial(props) {
  const location = useLocation();
  const activeTab = location.state?.activeTab || 0;
  const isCourseModuleReset = location.state?.reset || false;
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));
  const subjectDetail = location?.state?.subjectDetail;
  const subject_id = location?.state?.subjectId;
  const topic_id = location?.state?.topicId;
  const [videoProgress, setVideoProgress] = useState({});
  const [isDropDown, setIsDropDown] = useState({});
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isCloseButtonClicked, setCloseButtonClicked] = useState(false);
  const [rightsideBarOpen, setRightsideBarOpen] = useState(false);
  const [isRightSideBarButtonClicked, setRightSideBarButtonClicked] = useState(false);

  const handleVideoProgress = (videoKey, percent) => {
    if (videoKey) {
      setVideoProgress((prev) => ({
        ...prev,
        [videoKey]: percent,
      }));
    }
  };

  const [openSidebar, setOpenSidebar] = useState(false);
  const windowScreenWidth = useScreenWidth();
  const screenWidth = 900;

  function closeDrawer() {
    setOpenSidebar(false);
  }

  const [selectedQuizCard, setSelectedQuizCard] = useState(null);
  const [quizAttemptForResult, setQuizAttemptForResult] = useState(null);
  const [activeItem, setActiveItem] = useState(false);
  const [mySectionData, setMySectionData] = useState("");
  const t = useTranslations();
  const history = useHistory();
  const [selectedTab, setSelectedTab] = useState(0);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const userId = user?.user?._id ? user?.user?._id : user?._id;
  const classes = useStyles();
  const [testQuiz, setTestQuiz] = useState(false);
  const [sidebarData, setSidebarData] = useState([]);
  const [videoRefresh, setVideoRefresh] = useState(false);
  const [pdfOpen, setPdfOpen] = useState(false);
  const [sectionChanged, setSectionChanged] = useState(false);
  const [courseDataList, setCourseDataList] = useState([]);
  const [nextClick, setNextClick] = useState([]);
  const [showEvaluationTest, setShowEvaluationTest] = useState(false);
  const [activeIndex, setActiveIndex] = useState(activeTab);
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const [startButtonClicked, setStartButtonClicked] = useState(false);
  const [showInstructions, setShowInstructions] = useState(false);
  const [openpdf, setOpenpdf] = useState(false);
  const [pdfPath, setpdfPath] = useState("");
  const [sectionNumber, setSectionNumber] = useState([]);
  const [sectionName, setSectionName] = useState("");
  const [hasRendered, setHasRendered] = useState(false);
  const isVisible = useSelector((state) => state?.bottomBarReducer?.isVisible);
  const selfLearningTabRedirection = useSelector(state => state.filteredCourseList.selfLearningTab);
  const handleOpenPdf = () => setOpenpdf(true);
  const handleClosePdf = () => setOpenpdf(false);
  const [selectedSubmenu, setSelectedSubmenu] = useState(null);
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);
  const [currentDataIndex, setCurrentDataIndex] = useState(0);
  const [isDropdownOpen, setIsDropdownOpen] = useState(true);
  const [breadcrumbRefModel, setBreadcrumbRefModel] = useState(false);
  const [submittedTest, setSubmittedTest] = useState(false);
  const [isPracticeQuiz, setIsPracticeQuiz] = useState(false);
  const [isUnlockEvaluationTestModal, setIsUnlockEvaluationTestModal] = useState(false);
  const [lastUnlockModalCourseId, setLastUnlockModalCourseId] = useState(null);
  const [isCourseCompletedModal, setIsCourseCompletedModal] = useState(false);
  const [isNoEvaluationTestModal, setIsNoEvaluationTestModal] = useState(false);
  const [isPracticeQuizModal, setIsPracticeQuizModal] = useState(false);
  const [isCourseCompletedGamificationModal, setIsCourseCompletedGamificationModal] = useState(false);
  const [practiceQuizData, setPracticeQuizData] = useState("");
  const [courseCompletionData, setCourseCompletionData] = useState("");
  const [showCourseModalAfterQuiz, setShowCourseModalAfterQuiz] = useState(false);
  const [suppressCourseModal, setSuppressCourseModal] = useState(false);

  const settingsData = useSelector((state) => state.settingsReducers.settingsData?.data);

  // Determine if the course is expired
  const [isCourseExpired, setIsCourseExpired] = useState(location?.state?.isCourseExpired || false);
  useEffect(() => {
    if (mySectionData?.assignedCourseEndDate) {
      const now = new Date();
      const endDate = new Date(mySectionData.assignedCourseEndDate);
      const expired = endDate.getTime() < now.getTime();
      setIsCourseExpired(expired);
    }
  }, [mySectionData?.assignedCourseEndDate]);
  
  const handleResetView = () => {
    setCurrentSectionIndex(0);
    setCurrentDataIndex(0);
    setShowEvaluationTest(false);
    dispatch(toggleBottomBar(false));
  }

  useEffect(() => {
    setTimeout(() => {
      setHasRendered(true);
    }, 1000);
  }, [hasRendered]);

  useEffect(() => {
    // go to evaluation test page on evaluation unlock popup modal
    activeTab && setSelectedTab(activeTab);
    isCourseModuleReset && handleResetView();
  },[activeTab, isCourseModuleReset])
  
  const course_id = location?.state?.courseId ? location?.state?.courseId : mySectionData?.data?.courseId?._id;
  const savedMenu = localStorage.getItem('selectedMenu');

  useEffect(() => {
    if (
      mySectionData?.data?.progressPercent > 99 &&
      mySectionData?.data?.courseId?._id &&
      mySectionData?.isNotificationSend === false
    ) {
      let data = {
        tag: "courseCompletion",
        courseId: [mySectionData?.data?.courseId?._id],
        completedOn: new Date().toISOString(),
      };
      dispatch(courseAddedNotification(userId, data));
    }
  }, [mySectionData?.data?.progressPercent]);

  useEffect(() => {
    // user experience modal-> When evaluation test is unlocked (depends on the course progress configured from admin panel)

    if (!isCourseExpired && mySectionData?.data?.courseId?._id && mySectionData?.data?.progressPercent >= selectedQuizCard?.EvaluationUnlockPercent) {
      if (lastUnlockModalCourseId !== mySectionData?.data?.courseId?._id && mySectionData?.data?.evaluationTest?.[0]?.quizAttempts === 0) {
        setIsUnlockEvaluationTestModal(true);
        setLastUnlockModalCourseId(mySectionData?.data?.courseId?._id);
      }
    }

    // user experience modal when When the user completes the course 

    if(!isCourseExpired && mySectionData?.data?.courseId?._id && mySectionData?.data?.progressPercent > 99 && courseCompletionData?.isCompleted && !suppressCourseModal && !showCourseModalAfterQuiz && !isCourseCompletedModal) {
      if (settingsData?.data?.[0]?.gamification?.enabled) {
        setIsCourseCompletedGamificationModal(true);
      } else {
        setIsCourseCompletedModal(true);
      }
      setSuppressCourseModal(true);
    }

    if(!isCourseExpired && mySectionData?.data?.courseId?._id && mySectionData?.data?.progressPercent > 99 && selectedQuizCard?.EvaluationUnlockPercent === undefined && !suppressCourseModal) {
        setIsNoEvaluationTestModal(true);
    }
  },[mySectionData?.data?.progressPercent, mySectionData?.data?.courseId?._id, selectedQuizCard?.EvaluationUnlockPercent, lastUnlockModalCourseId, suppressCourseModal, showCourseModalAfterQuiz, courseCompletionData?.isCompleted])

  useEffect(() => {
    userId && dispatch(recentCourseListAction(userId));
  }, [userId]);

  useEffect(() => {
    if (sidebarData?.refModel === "Questions" || breadcrumbRefModel) {
      setIsPracticeQuiz(true);
      setSubmittedTest(false);
    } else {
      setIsPracticeQuiz(false);
      setBreadcrumbRefModel(false);
    }
  }, [sidebarData]);

  useEffect(() => { // Redirect to 4 tabs self learning screen from results page header back button
    if(selfLearningTabRedirection !== undefined) {
      handleCourseNavigation();
    } else if (selfLearningTabRedirection === undefined && /^\/course\/[^/]+\/[^/]+$/.test(window.location.pathname)) {
      setShowEvaluationTest(false);
      setShowInstructions(false);
      dispatch(setShowEvaluationTestAction(false));
      dispatch(setShowInstructionsAction(false));
      history.push({ pathname: location?.pathname, state: { activeTab: 0, reset: true, courseId: course_id, courseName: mySectionData?.data?.courseId?.name, subjectDetail: subjectDetail, courseProgress: mySectionData?.data?.progressPercent  }});
    } else {
      history.push(`/course/${course_id}`, {  activeTab: 0, reset: true, courseId: course_id, courseName: mySectionData?.data?.courseId?.name, subjectId: '', topicId: '', subjectDetail: subjectDetail, subjectName: '', topicName: '', showEvaluationTest: showEvaluationTest, showInstructions: showInstructions, courseProgress: mySectionData?.data?.progressPercent });
      setShowEvaluationTest(false);
      setShowInstructions(false);
      dispatch(setShowEvaluationTestAction(false));
      dispatch(setShowInstructionsAction(false));
    }
  }, [selfLearningTabRedirection]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSubmenuClick = (data) => {
    setSidebarData(data?.data);
  };

  const processSectionDataFromItem = (index, itemIndex) => {
    const newSectionData = mySectionData?.data;
    newSectionData?.section?.forEach((section, sectionIndex) => {
      if (sectionIndex >= index) {
        setSectionNumber((prevState) => [
          ...prevState,
          section.courseSectionData.length,
        ]);

        if (sectionIndex === index) {
          setSectionName(section?.title?.en);
          const sectionData = [...section?.courseSectionData];

          setNextClick([
            {
              ...sectionData[itemIndex],
              sectionId: section?._id,
              title: section?.title,
            },
          ]);

          setIsDropDown((prevState) => ({
            ...prevState,
            [sectionIndex]: true,
          }));

          setCourseDataList((prevState) => [
            ...prevState,
            ...sectionData.map((data1) => ({
              ...data1,
              sectionId: section?._id,
              title: section?.title,
            })),
          ]);

        } else {
          setIsDropDown((prevState) => ({
            ...prevState,
            [sectionIndex]: false,
          }));

          setCourseDataList((prevState) => [
            ...prevState,
            ...section?.courseSectionData.map((data1) => ({
              ...data1,
              sectionId: section?._id,
              title: section?.title,
            })),
          ]);
        }
      }
    });
  };

  const handleRightSidebarClose = () => {
    setCloseButtonClicked(true);
    setIsSidebarCollapsed(true);
    setRightsideBarOpen(false);
    setRightSideBarButtonClicked(false);
  }

  const handleRightSidebarOpen = () => {
    setRightSideBarButtonClicked(true);
    setCloseButtonClicked(false);
    setRightsideBarOpen(true);
    setIsSidebarCollapsed(false);
  }

  const handleMenuItemClick = (selectedItem) => {
    let foundSectionIndex = null;
    let foundItemIndex = null;

    mySectionData?.data?.section?.forEach((section, sectionIndex) => {
      const itemIndex = section.courseSectionData.findIndex(
        (csd) => csd._id === selectedItem._id
      );
      if (itemIndex !== -1) {
        foundSectionIndex = sectionIndex;
        foundItemIndex = itemIndex;
      }
    });

    if (foundSectionIndex !== null && foundItemIndex !== null) {
      processSectionDataFromItem(foundSectionIndex, foundItemIndex);
      dispatch(setDataId(selectedItem?._id));
      setCurrentSectionIndex(foundSectionIndex);
      setCurrentDataIndex(foundItemIndex);
      dispatch(setShowEvaluationTestAction(true));
      setShowEvaluationTest(true);
      dispatch(setCourseProgress(mySectionData?.data?.progressPercent));
      setSidebarData((prev) => ({
        ...prev,
        refModel: false,
      }));
      handleClose();
    }
    if(selectedItem?.refModel==="Questions") {
      setBreadcrumbRefModel(true);
    } else {
      setBreadcrumbRefModel(false);
    }
  };

  useEffect(() => {
    const savedTab = localStorage.getItem("selectedTab");
    if (savedTab) {
      setSelectedTab(Number(savedTab));
    }
  }, [testQuiz]);

  const handleVideoRefresh = (value) => {
    setVideoRefresh(value);
  };

  const handlePdfOpen = (value) => {
    setPdfOpen(value);
  };

  function handleTabChange(value) {
    setSelectedTab(value);
  }

  let tabBarList = [
    {
      id: 0,
      label: t("SELF LEARNING"),
      icon: <SelfLearning className={classes.selfLearningIcon} />,
      activeIcon: (
        <img
          alt=""
          src={ActiveSelfLearn}
          className={classes.selfLearningIcon}
        />
      ),
      customBadgeClass: "customBadge1",
    },
    {
      id: 1,
      label: t("LIVE CLASSES"),
      icon: <Live className={classes.liveClassesIcon} />,
      activeIcon: (
        <img alt="" src={ActiveLiveClass} className={classes.liveClassesIcon} />
      ),
      customBadgeClass: "customBadge2",
    },
    {
      id: 2,
      label: t("EVALUATION TEST"),
      icon: <MockTest className={classes.evaluationTestIcon} />,
      activeIcon: (
        <img
          alt=""
          src={ActiveMockTest}
          className={classes.evaluationTestIcon}
        />
      ),
      customBadgeClass: "customBadge3",
    },
    {
      id: 3,
      label: t("CERTIFICATE"),
      icon: <Certificate className={classes.certificateTestIcon} />,
      activeIcon: (
        <img
          alt=""
          src={ActiveCertificate}
          className={classes.certificateTestIcon}
        />
      ),
      customBadgeClass: "customBadge4",
    },
  ];
  const [isFeedbackModelOpen, setIsFeedbackModelOpen] = useState(false);
  const [downloadCertificateButton, setdownloadCertificateButton] =
    useState(false);

  function goToDashboard() {
    history.goBack();
  }

  function goToCourseScreen() {
    if(savedMenu === "/courses") {
      history.push("/courses");
    } else if (savedMenu === "/course-package") {
      history.push("/course-package");
    } else {
      history.push('/my-courses', { params: window.location.pathname});
    }
  }

  function openFeedback() {
    setIsFeedbackModelOpen(true);
  }

  function onQuizCardClick(data) {
    setSelectedQuizCard(data);
    setTestQuiz(true);
  }

  useEffect(() => {
    dispatch(getSelfLearningAction(course_id)).then((res) => {
      setMySectionData(res);
      dispatch(setCourseProgress(res?.data?.progressPercent));
      dispatch(setCourseName(res?.data?.courseId?.name));
      setSelectedQuizCard(res?.data?.evaluationTest[0]?.testId);
      setQuizAttemptForResult(res?.data?.evaluationTest[0]?.quizAttempts);
    });
  }, [course_id, videoRefresh, pdfOpen]);

  useEffect(() => {
    document.title = `${
      selectedTab === 0
        ? t("SELF LEARNING")
        : selectedTab === 1
        ? t("LIVE_CLASS")
        : selectedTab === 2
        ? t("EVALUATION TEST")
        : selectedTab === 3
        ? t("CERTIFICATE")
        : ""
    } | LMS`;
  }, [selectedTab]);

  const showInstructionScreen = () => {
    dispatch(setShowInstructionsAction(true));
    setShowInstructions(true);
  };

  const getCourseSectionApiData = async () => {
    try {
      if (course_id !== undefined || showInstructions) {
        setMySectionData(mySectionData);
        dispatch(setCourseProgress(mySectionData?.data?.progressPercent));
        dispatch(setCourseName(mySectionData?.data?.courseId?.name));
        mySectionData?.data?.section.map((sectionData, index) => {
          setSectionNumber((preState) => [
            ...preState,
            sectionData.courseSectionData.length,
          ]);
          if (index === 0) {
            setNextClick([
              {
                ...sectionData.courseSectionData[0],
                sectionId: sectionData._id,
                title: sectionData.title,
              },
            ]);
            sectionData.courseSectionData.shift();
          }
          setCourseDataList((preState) => [
            ...preState,
            ...[...sectionData.courseSectionData].map((data) => {
              return {
                ...data,
                sectionId: sectionData._id,
                title: sectionData.title,
              };
            }),
          ]);
        });
        if (!props.activeItem && typeof mySectionData != "undefined") {
          setActiveItem({
            data: mySectionData?.data?.section[0],
            sectionData: mySectionData,
          });
        }
      }
    } catch (error) {
      console.log("Error - ", error.message);
    }
  };

  let courseSectionData = mySectionData?.data?.section;
  let courseId = mySectionData?.data?.courseId?._id;

  // Highlighting the submenu items

  const firstSectionItem = courseSectionData?.[currentSectionIndex];
  const firstItemId =
    firstSectionItem?.courseSectionData[currentDataIndex]?._id;
  useEffect(() => {
    setSelectedSubmenu(firstItemId);
  }, [firstItemId]);

  function handleNextId() {
    let localCurrentSectionIndex = currentSectionIndex;
    let localCurrentDataIndex = currentDataIndex;

    if (!courseSectionData || courseSectionData.length === 0) {
      return;
    }
    if (localCurrentSectionIndex >= courseSectionData.length) {
      return;
    }

    let section = courseSectionData[localCurrentSectionIndex];
    localCurrentDataIndex++;
    setCurrentDataIndex(localCurrentDataIndex);

    // Check if we need to move to the next section
    if (localCurrentDataIndex >= section?.courseSectionData?.length) {
      localCurrentDataIndex = 0;
      setCurrentDataIndex(localCurrentDataIndex);
      localCurrentSectionIndex++;
      setCurrentSectionIndex(localCurrentSectionIndex);
    }

    if (localCurrentSectionIndex >= courseSectionData.length) {
      return;
    }

    section = courseSectionData[localCurrentSectionIndex];
    const data = section?.courseSectionData[localCurrentDataIndex];

    const res = {
      sectionId: section?._id,
      dataId: data?._id,
      courseId,
      submenu: {
        data,
        section,
        activeItem,
        pdfOpen,
        nextClick,
        sectionName,
        sectionId: section?._id,
      },
    };

    handleNextClick(res);
  }

  const handleNextClick = ({ sectionId, dataId, courseId, submenu = {} }) => {
    setSelectedSubmenu(dataId);
    if (submenu?.data?.refModel === "RecordedVideo") {
      dispatch(selfLearningVideoUrl(submenu));
      setSectionChanged(false);
    } else if (submenu?.data?.refModel === "TextNotes") {
      dispatch(selfLearningVideoUrl(submenu));
      let data = {
        sectionId,
        dataId,
        percent: 100,
        courseId,
        isRead: true,
      };
      handleUpdateCourseProgress(data);
    } else if (submenu?.data?.refModel === "PdfNotes") {
      let data = {
        sectionId,
        dataId,
        percent: 100,
        courseId,
        isRead: true,
      };
      handleUpdateCourseProgress(data);
      handlePdfOpen(pdfOpen);
      openPdfViewer(submenu?.data?.contentData?.featured);
    }
    if (handleSubmenuClick) {
      handleSubmenuClick(submenu);
    }
  };

  const handlePrevClick = () => {
    setBreadcrumbRefModel(false);
    let localCurrentSectionIndex = currentSectionIndex;
    let localCurrentDataIndex = currentDataIndex;

    if (!courseSectionData || courseSectionData.length === 0) {
      return;
    }
    if (localCurrentDataIndex <= 0 && localCurrentSectionIndex <= 0) {
      return;
    }

    let section = {};

    // Check if we need to move to the previous section
    if (localCurrentDataIndex <= 0 && localCurrentSectionIndex > 0) {
      localCurrentSectionIndex--;
      setCurrentSectionIndex(localCurrentSectionIndex);
      section = courseSectionData[localCurrentSectionIndex];
      localCurrentDataIndex = section?.courseSectionData?.length - 1;
      setCurrentDataIndex(localCurrentDataIndex);
    } else {
      section = courseSectionData[localCurrentSectionIndex];
      localCurrentDataIndex--;
      setCurrentDataIndex(localCurrentDataIndex);
    }

    const data = section?.courseSectionData[localCurrentDataIndex];

    const res = {
      sectionId: section?._id,
      dataId: data?._id,
      courseId,
      submenu: {
        data,
        section,
        activeItem,
        pdfOpen,
        nextClick,
        sectionName,
        sectionId: section?._id,
      },
    };
    handleNextClick(res);
  };

  useEffect(() => {
    if (showEvaluationTest) {
      if (
        nextClick.length &&
        nextClick[nextClick.length - 1].refModel === "PdfNotes"
      ) {
        handleOnClick(nextClick.length - 1);
      } else if (
        nextClick.length &&
        nextClick[nextClick.length - 1].refModel === "TextNotes"
      ) {
        handleOnClick(nextClick.length - 1);
      } else if (
        nextClick.length &&
        nextClick[nextClick.length - 1].refModel === "RecordedVideo"
      ) {
        dispatch(selfLearningVideoUrl(nextClick[0]));
      }
    }
  }, [nextClick, showEvaluationTest]);

  const handleUpdateCourseProgress = (data) => {
  dispatch(getProgressBarDetails(data)).then((res) => {
    setCourseCompletionData(res);
    dispatch(getSelfLearningAction(course_id)).then((res) => {
      setMySectionData(res);
      dispatch(setCourseProgress(res?.data?.progressPercent));
    });
  });
};

  const handleOnClick = (index) => {
    dispatch(setDataId(nextClick[index]?._id));
    if (nextClick[index]?.refModel === "PdfNotes") {
      let percent = 100;
      let data = {
        sectionId: nextClick[index]?.sectionId,
        dataId: nextClick[index]?._id,
        percent: percent,
        courseId: mySectionData?.data?.courseId?._id,
        isRead: true,
      };
      handleUpdateCourseProgress(data);
      handlePdfOpen(pdfOpen);
      openPdfViewer(nextClick[index]?.contentData?.featured);
    } else if (nextClick[index]?.refModel === "TextNotes") {
      let percent = 100;
      let data = {
        sectionId: nextClick[index]?.sectionId,
        dataId: nextClick[index]?._id,
        percent: percent,
        courseId: mySectionData?.data?.courseId?._id,
        isRead: true,
      };
      handleUpdateCourseProgress(data);
    } else if (nextClick[index]?.refModel === "RecordedVideo") {
      let data = {
        sectionId: nextClick[index]?.sectionId,
        dataId: nextClick[index]?._id,
        percent: 0,
        courseId: mySectionData?.data?.courseId?._id,
      };
      handleUpdateCourseProgress(data);
    }
  };

  function handleCourseNavigation() { // go back to 4 tabs function
    handleRightSidebarOpen();
    setShowEvaluationTest(false);
    setShowInstructions(false);
    setSidebarData([]);
    dispatch(setShowEvaluationTestAction(false));
    dispatch(setShowInstructionsAction(false));
    dispatch(setCourseName(mySectionData?.data?.courseId?.name));
    dispatch(setCourseProgress(mySectionData?.data?.progressPercent));
    dispatch(toggleBottomBar(false))
    setHasRendered(false);
  }

  const openPdfViewer = (path) => {
    setpdfPath(path);
    handleOpenPdf();
  };
  useEffect(() => {
    getCourseSectionApiData();
  }, [course_id]);
  useEffect(() => {
    localStorage.setItem("selectedTab", selectedTab);
  }, [selectedTab]);

  const drawerToggle = JSON.parse(localStorage.getItem("openDrawerStatus"));

  const closeUnlockEvaluationTestModal = () => {
    setIsUnlockEvaluationTestModal(false);
  }

  const closeCourseCompletedModal = () => {
    setIsCourseCompletedModal(false);
  }

  const closeNoEvaluationTestModal = () => {
    setIsNoEvaluationTestModal(false);
  }

  const closePracticeQuizModal = () => {
    setIsPracticeQuizModal(false);
  }

  const handleContinueLearning = () => {
    setIsPracticeQuizModal(false);
    if (showCourseModalAfterQuiz && mySectionData?.data?.progressPercent > 99) {
      if (selectedQuizCard?.EvaluationUnlockPercent === undefined) {
        setIsNoEvaluationTestModal(true);
      } else {
        if (settingsData?.data?.[0]?.gamification?.enabled) {
          setIsCourseCompletedGamificationModal(true);
        } else {
          setIsCourseCompletedModal(true);
        }
      }
      setShowCourseModalAfterQuiz(false); // reset course modal after quiz
    }
  }

  const closeCourseCompletedGamificationModal = () => {
    setIsCourseCompletedGamificationModal(false);
  };

  const handleEvaluationTest = () => {
    history.push({ pathname: location?.pathname, state: { activeTab: 2, reset: true, courseId: course_id, courseName: mySectionData?.data?.courseId?.name, subjectDetail: subjectDetail, courseProgress: mySectionData?.data?.progressPercent  }});
    dispatch(setShowInstructionsAction(true));
    closeUnlockEvaluationTestModal();
  }
  
  const getBadgeIcon = (badgeTitle, badgeUrl) => {
    if (badgeUrl && badgeUrl !== "default") {
      const imgSrc = badgeUrl.startsWith("http") ? badgeUrl : `${process.env.REACT_APP_BACKEND_URL}/badge/image/${badgeUrl}`;
      return <img src={imgSrc} alt={badgeTitle} className={classes.statIcon} style={{ objectFit: 'contain' }} />;
    }
    switch (badgeTitle) {
      case "Master":
        return <GoldBadge className={classes.statIcon} />;
      case "Knowledge Seeker":
        return <BronzeBadge className={classes.statIcon} />;
      case "Challenger":
        return <PlatinumBadge className={classes.statIcon} />;
      default:
        return <PlatinumBadge className={classes.statIcon} />;
    }
  };

  const PracticeQuizModal = ({ showModal, onClose }) => {
    return (
      <Box className={classes.modalBg + ` ${showModal ? "show" : ""}`} onClick={(e) => e.stopPropagation()}>
        <Box className={classes.modalContent} onClick={(e) => e.stopPropagation()}>
          <Box className={classes.headingModalGamification}>
            <PracticeQuizCompletedIcon className={classes.icon} />
            <Box className={classes.starVectorBox}>
              <StarVector1 className={classes.starVector1}/>
              <StarVector2 className={classes.starVector2}/>
              <StarVector3 className={classes.starVector3}/>
            </Box>
            <Typography variant="h2" className={classes.modalHeadingGamification}>
              {t('Well Done')}
            </Typography>
            <Typography variant="inherit" className={classes.modalSubtextGamification}>
              {t('You have successfully completed the')} <strong>{mySectionData?.data?.courseId?.name}</strong> {t('practice quiz and earned points')}
            </Typography>
            <Box className={classes.statsWrapper}>
               {practiceQuizData?.payload?.newBadgesAwarded?.[0]?.title && <Box className={classes.statGroup}>
                <Box className={classes.statBox}>
                  {getBadgeIcon(practiceQuizData?.payload?.newBadgesAwarded?.[0]?.title, practiceQuizData?.payload?.newBadgesAwarded?.[0]?.badgeUrl)}
                  <Typography className={classes.statValue}>{practiceQuizData?.payload?.newBadgesAwarded?.[0]?.title}</Typography>
                </Box>
                <Typography className={classes.statLabel}>{t('Badge')}</Typography>
              </Box>}

              {practiceQuizData?.payload?.pointsEarned > 0 && <Box className={classes.statGroup}>
                <Box className={classes.statBox}>
                  <PointsIcon className={classes.statIcon} />
                  <Typography className={classes.statValue}>{practiceQuizData?.payload?.pointsEarned}</Typography>
                </Box>
                <Typography className={classes.statLabel}>{t('Points')}</Typography>
              </Box>}

              {practiceQuizData?.payload?.achievedLevels?.[0]?.criteriaTitle && <Box className={classes.statGroup}>
                <Box className={classes.statBox}>
                  <LevelUpIcon className={classes.statIcon} />
                  <Typography className={classes.statValue}>{practiceQuizData?.payload?.achievedLevels?.[0]?.criteriaTitle}</Typography>
                </Box>
                <Typography className={classes.statLabel}>{t('Level')}</Typography>
              </Box>}
            </Box>
            {practiceQuizData?.payload?.newBadgesAwarded?.[0]?.title && (
              <Box style={{ display: 'flex', justifyContent: 'center', marginTop: '12px' }}>
                <BadgeSharePopover badge={practiceQuizData?.payload?.newBadgesAwarded?.[0]} />
              </Box>
            )}
            <CommonButton classStyleHeading={classes.okBtnGamification} title={t("Continue Learning")} onClick={handleContinueLearning} />
          </Box>
        </Box>
      </Box>
    )
  }

  const EvaluationUnlockModal = ({ showModal, onClose }) => {
    return (
      <Box className={classes.modalBg + ` ${showModal ? "show" : ""}`} onClick={closeUnlockEvaluationTestModal}>
        <Box className={classes.modalContent} onClick={(e) => e.stopPropagation()}>
          <Box className={classes.headingModal}>
            <TestUnlockedIcon className={classes.icon} />
            <Box className={classes.starVectorBox}>
              <StarVector1 className={classes.starVector1}/>
              <StarVector2 className={classes.starVector2}/>
              <StarVector3 className={classes.starVector3}/>
            </Box>
            <Typography variant="h2" className={classes.modalHeading}>
              {t('Evaluation Test Unlocked')}
            </Typography>
            <Typography variant="inherit" className={classes.modalSubtext}>
              {t('You can now attempt the evaluation test')}
            </Typography>
            <CommonButton classStyleHeading={classes.okBtn} title={t("Start Test Now")} onClick={()=>{handleEvaluationTest(); closeUnlockEvaluationTestModal();}} />
            <Link component="button" underline="none" className={classes.goToCoursesLink} onClick={closeUnlockEvaluationTestModal}>
              {t('Later')}
            </Link>
          </Box>
        </Box>
      </Box>
    )
  }

  const CourseCompletionModal = ({ showModal, onClose }) => {
    return (
      <Box className={classes.modalBg + ` ${showModal ? "show" : ""}`} onClick={onClose}>
        <Box className={classes.modalContent} onClick={(e) => e.stopPropagation()}>
          <Box className={classes.headingModal}>
            <CourseCompletedIcon className={classes.icon} />
            <Typography variant="h2" className={classes.modalHeading}>
              {t('Great job!')}
            </Typography>
            <Typography variant="inherit" className={classes.modalSubtext}>
              {t('You have completed the')} <strong>{mySectionData?.data?.courseId?.name}</strong> {t('Take the evaluation test')}
            </Typography>
            <CommonButton classStyleHeading={classes.okBtn} title={t("Take Evaluation Test")} onClick={()=>{handleEvaluationTest(); closeCourseCompletedModal();}} />
            <Link component="button" underline="none" className={classes.goToCoursesLink} onClick={closeCourseCompletedModal}>
              {t('Back To Course')}
            </Link>
          </Box>
        </Box>
      </Box>
    )
  }

  const CourseCompletionGamificationModal = ({ showModal, onClose }) => {
    return (
      <Box className={classes.modalBg + ` ${showModal ? "show" : ""}`} onClick={onClose}>
        <Box className={classes.modalContent} onClick={(e) => e.stopPropagation()}>
          <Box className={classes.headingModalGamification}>
            <CourseCompletedIcon className={classes.icon} />
            <Box className={classes.starVectorBox}>
              <StarVector1 className={classes.starVector1}/>
              <StarVector2 className={classes.starVector2}/>
              <StarVector3 className={classes.starVector3}/>
            </Box>
            <Typography variant="h2" className={classes.modalHeadingGamification}>
              {t('Course Completed')}
            </Typography>
            <Typography variant="inherit" className={classes.modalSubtextGamification}>
              {t('You have completed')} <strong>{mySectionData?.data?.courseId?.name}</strong> {t('earned points, badges, and a level upgrade')}
            </Typography>
            <Box className={classes.statsWrapper}>
              {courseCompletionData?.newBadgesAwarded?.[0]?.title && <Box className={classes.statGroup}>
                <Box className={classes.statBox}>
                  {getBadgeIcon(courseCompletionData?.newBadgesAwarded?.[0]?.title, courseCompletionData?.newBadgesAwarded?.[0]?.badgeUrl)}
                  <Typography className={classes.statValue}>{courseCompletionData?.newBadgesAwarded?.[0]?.title}</Typography>  
                </Box>
                <Typography className={classes.statLabel}>{t('Badge')}</Typography>
              </Box>}
              {courseCompletionData?.pointsEarned > 0 && <Box className={classes.statGroup}>
                <Box className={classes.statBox}>
                  <PointsIcon className={classes.statIcon} />
                  <Typography className={classes.statValue}>{courseCompletionData?.pointsEarned}</Typography>
                </Box>
                <Typography className={classes.statLabel}>{t('Points')}</Typography>
              </Box>}
              {courseCompletionData?.achievedLevels?.[0]?.criteriaTitle && courseCompletionData?.achievedLevels?.[0]?.isLevelStatusActive && <Box className={classes.statGroup}>
                <Box className={classes.statBox}>
                  <LevelUpIcon className={classes.statIcon} />
                  <Typography className={classes.statValue}>{courseCompletionData?.achievedLevels?.[0]?.criteriaTitle}</Typography>
                </Box>
                <Typography className={classes.statLabel}>{t('Level')}</Typography>
              </Box>}
            </Box>
            {courseCompletionData?.newBadgesAwarded?.[0]?.title && (
              <Box style={{ display: 'flex', justifyContent: 'center', marginTop: '12px' }}>
                <BadgeSharePopover badge={courseCompletionData?.newBadgesAwarded?.[0]} />
              </Box>
            )}
            {selectedQuizCard?.EvaluationUnlockPercent !== undefined && <CommonButton classStyleHeading={classes.okBtnGamification} title={t("Take Evaluation Test")} onClick={()=>{handleEvaluationTest(); closeCourseCompletedGamificationModal();}} />}
            <Link component="button" underline="none" className={classes.goToCoursesLinkGamification} onClick={closeCourseCompletedGamificationModal}>
              {t('Back To Course')}
            </Link>
          </Box>
        </Box>
      </Box>
    )
  }

  const NoEvaluationTestModal = ({ showModal, onClose }) => {
    return (
      <Box className={classes.modalBg + ` ${showModal ? "show" : ""}`} onClick={closeNoEvaluationTestModal}>
        <Box className={classes.modalContent} onClick={(e) => e.stopPropagation()}>
          <Box className={classes.headingModal}>
            <CourseCompletedIcon className={classes.icon} />
            <Box className={classes.starVectorBox}>
              <StarVector1 className={classes.starVector1}/>
              <StarVector2 className={classes.starVector2}/>
              <StarVector3 className={classes.starVector3}/>
            </Box>
            <Typography variant="h2" className={classes.modalHeading}>
              {t('Course Completed')}
            </Typography>
            <Box>
              <Typography variant="inherit" className={classes.modalSubtext}>
                {t('Well done on finishing the')} <strong>{mySectionData?.data?.courseId?.name}</strong> {t('Keep the momentum going')}
              </Typography>
            </Box>
            <CommonButton classStyleHeading={classes.okBtn} title={t("Back To Course")} onClick={() => {closeNoEvaluationTestModal()}}/>
            <Link component="button" underline="none" className={classes.goToCoursesLink} onClick={() => {closeNoEvaluationTestModal(); history.push('/courses')}}>
              {t('Explore More Courses')}
            </Link>
          </Box>
        </Box>
      </Box>
    )
  }

  return (
    <>
      <Grid
        container
        spacing={0}
        className={drawerToggle ? classes.mainFragmentExpand : classes.fragment}
      >
        {(!isMobile || isVisible && !showInstructions) && (
          <Box
            className={
              "container sticky-header" + (openSidebar ? "open-drawer" : "")
            }
            onClick={
              windowScreenWidth <= screenWidth
                ? closeDrawer.bind(this)
                : () => null
            }
          >
            <Box className={classes.heading}>
              {mySectionData?.data?.courseId?.name && (
                <Breadcrumbs
                  aria-label="breadcrumb"
                  className={classes.breadcrumbsWrap}
                >
                  {!isMobile && !showEvaluationTest && !showInstructions && ( // before start learning button show this
                    <Typography
                      variant="inherit"
                      color="inherit"
                      style={{ cursor: "pointer", marginLeft: '24px' }}
                      onClick={() => goToCourseScreen()}
                    >
                      {savedMenu === "/courses"
                        ? t("COURSES")
                        : savedMenu === "/course-package"
                        ? t("Course Package")
                        : t("MY_COURSES")}
                    </Typography>
                  )}
                  {(!isMobile && (showEvaluationTest && !showInstructions) || (!showEvaluationTest && showInstructions)) && (
                    <Box className={classes.arrowButtonHeader}>
                      <ArrowBackIcon
                        style={{ cursor: "pointer" }}
                        onClick={handleCourseNavigation}
                      />
                      <Typography
                        key="tabLabel"
                        variant="inherit"
                        color="inherit"
                        className={
                          (showEvaluationTest && !showInstructions) || (!showEvaluationTest && showInstructions)
                            ? `ellipsis-typography ${classes.breadcrumbsText}`
                            : `ellipsis-full-size ${classes.breadcrumbsText}`
                        }
                      >
                        <Tooltip title={mySectionData?.data?.courseId?.name} aria-label="add">
                          <Typography variant="inherit">{mySectionData?.data?.courseId?.name}</Typography>
                        </Tooltip>
                      </Typography>
                    </Box>
                  )}
                  {(isMobile && showEvaluationTest && !showInstructions) && ( // show Section names in mobile view to navigate
                    <Box className={classes.mobileSectionNameDropdown}>
                      <Typography
                        variant="inherit"
                        color="inherit"
                        style={{ fontSize: isMobile ?  "14px" : "1rem", paddingRight: "5px" }}
                      >
                        {courseSectionData[currentSectionIndex]?.title?.en}
                      </Typography>
                      <IconButton
                        aria-controls="section-menu"
                        aria-haspopup="true"
                        onClick={handleClick}
                        style={{ padding: 0 }}
                      >
                        <ExpandMoreIcon />
                      </IconButton>
                    </Box>
                  )}
                  {/* Dropdown Menu */}
                  {isMobile && <Menu
                    id="breadcrumb-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    style={{ top: "40px" }}
                  >
                    {(
                      mySectionData?.data?.section[currentSectionIndex || 0]
                        ?.courseSectionData || []
                    ).map((item) => {
                      const iconName = item?.refModel;

                      const renderIcon = () => {
                        switch (iconName) {
                          case "Quiz":
                          case "Questions":
                            return <QuizIcon />;
                          case "RecordedVideo":
                            return <VideoIcon />;
                          case "PdfNotes":
                            return <PDFIcon />;
                          case "TextNotes":
                            return <TextIcon />;
                          default:
                            return null;
                        }
                      };

                      return (
                        <MenuItem
                          key={item._id}
                          onClick={() => handleMenuItemClick(item)}
                        >
                          <ListItemIcon
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                              gap: '10px',
                              fontSize: isMobile && '14px'
                            }}
                          >
                            {renderIcon()}
                            <Typography variant="inherit" style={{ flex: 1, whiteSpace: 'initial' }}>
                              {item.name}
                            </Typography>
                            {item?.isRead  ? (
                              <Box ml={1}>
                                <GreenTick/>
                              </Box>
                            ) : <Box><LinearProgressCircular value={item?.percent} width={20}/></Box>}
                          </ListItemIcon>
                        </MenuItem>
                      );
                    })}
                  </Menu>}
                </Breadcrumbs>
              )}
            </Box>
            {!showEvaluationTest && !showInstructions ? <Box
              className="notification-bar"
            >
              <NotificationBar openFeedbackModel={openFeedback} />
              </Box> : 
              <Box className={classes.courseProgressLayout}>
                {!isMobile && <LinearProgressWithLabel value={mySectionData?.data?.progressPercent} width={24} />}
              </Box>
            }
          </Box>
        )}
        <Box className="main-division">
          <Grid container>
            <Grid
              item
              xs={12}
              md={!showInstructions ? (isSidebarCollapsed ? 11 : 9) : 12}
              id="course-info-section"
              className={classes.mainLeftContainer}
            >
              {sidebarData?.refModel && showEvaluationTest && (
                <Card className={classes.cardClass}>
                  <CardContent className={classes.cardContentClass}>
                    <TabsLandingPage
                      selectedIndex={selectedTab}
                      course_id={course_id}
                      tabBarList={tabBarList}
                      mySectionData={mySectionData}
                      setMySectionData={setMySectionData}
                      subject_id={subject_id}
                      topic_id={topic_id}
                      subjectDetail={subjectDetail}
                      history={history}
                      downloadCertificateButton={downloadCertificateButton}
                      goToDashboard={goToDashboard}
                      setActiveItem={setActiveItem}
                      activeItem={activeItem}
                      onVideoRefresh={handleVideoRefresh}
                      videoRefresh={videoRefresh}
                      sectionChanged={sectionChanged}
                      setSectionChanged={setSectionChanged}
                      courseName={mySectionData?.data?.courseId?.name}
                      courseDescription={
                        mySectionData?.data?.courseId?.description
                      }
                      isSelfLearning={
                        mySectionData?.data?.courseId?.isSelfLearning
                      }
                      isLive={mySectionData?.data?.courseId?.isLive}
                      quizAttemptForResult={
                        quizAttemptForResult != null && quizAttemptForResult
                      }
                      quizAttempCourseId={mySectionData?.data?.courseId?._id}
                      coursePercentage={mySectionData?.data?.progressPercent}
                      pdfOpen={pdfOpen}
                      videoProgress={videoProgress}
                      handleVideoProgress={handleVideoProgress}
                      item={sidebarData}
                      showEvaluationTest={showEvaluationTest}
                      setStartButtonClicked={setStartButtonClicked}
                      startButtonClicked={startButtonClicked}
                      setShowInstructions={setShowInstructions}
                      showInstructions={showInstructions}
                      showInstructionScreen={showInstructionScreen}
                      openpdf={openpdf}
                      openPdfViewer={openPdfViewer}
                      handleClosePdf={handleClosePdf}
                      handleOpenPdf={handleOpenPdf}
                      pdfPath={pdfPath}
                      setpdfPath={setpdfPath}
                      sectionName={sectionName}
                      setSectionNumber={setSectionNumber}
                      setSectionName={setSectionName}
                      handleUpdateCourseProgress={handleUpdateCourseProgress}
                      selectedSubmenu={selectedSubmenu}
                      setSelectedSubmenu={setSelectedSubmenu}
                      currentSectionIndex={currentSectionIndex}
                      setCurrentSectionIndex={setCurrentSectionIndex}
                      currentDataIndex={currentDataIndex}
                      setCurrentDataIndex={setCurrentDataIndex}
                      isDropdownOpen={isDropdownOpen}
                      setIsDropdownOpen={setIsDropdownOpen} 
                      setSubmittedTest={setSubmittedTest}
                      setIsPracticeQuizModal={setIsPracticeQuizModal}
                      setPracticeQuizData={setPracticeQuizData}
                      setShowCourseModalAfterQuiz={setShowCourseModalAfterQuiz}
                      setSuppressCourseModal={setSuppressCourseModal}
                      isCourseExpired={isCourseExpired}
                      neverExpired={mySectionData?.neverExpired}
                    />
                  </CardContent>
                  <Box className={classes.sectionButtons}>
                    <Button
                      className={classes.sectionPrevBtn}
                      disabled={
                        currentSectionIndex <= 0 && currentDataIndex <= 0
                      }
                      variant="contained"
                      color="primary"
                      onClick={() => {handleClose(); handlePrevClick()}}
                    >
                      {t("Previous")}
                    </Button>
                    <Button
                      className={classes.sectionNextBtn}
                      disabled={
                        (isPracticeQuiz && !submittedTest) || (
                          currentSectionIndex >= courseSectionData?.length - 1 &&
                          currentDataIndex >=
                          courseSectionData[currentSectionIndex]?.courseSectionData?.length - 1
                        )
                      }
                      variant="contained"
                      color="primary"
                      onClick={() =>  {handleClose(); handleNextId()}}
                    >
                      {t("Next")}
                    </Button>
                  </Box>
                </Card>
              )}
              {showEvaluationTest && !sidebarData?.refModel ? (
                <Card className="card-class" style={{ background: "#fafafa" }}>
                  {nextClick.map((course, index) => {
                    return (
                      <div key={index} id={`course-${index}`}>
                        <CardContent className={classes.cardContentClass}>
                          <TabsLandingPage
                            selectedIndex={selectedTab}
                            course_id={course_id}
                            tabBarList={tabBarList}
                            subject_id={subject_id}
                            mySectionData={mySectionData}
                            setMySectionData={setMySectionData}
                            topic_id={topic_id}
                            subjectDetail={subjectDetail}
                            history={history}
                            downloadCertificateButton={
                              downloadCertificateButton
                            }
                            goToDashboard={goToDashboard}
                            setActiveItem={setActiveItem}
                            activeItem={activeItem}
                            onVideoRefresh={handleVideoRefresh}
                            videoRefresh={videoRefresh}
                            sectionChanged={sectionChanged}
                            setSectionChanged={setSectionChanged}
                            courseName={mySectionData?.data?.courseId?.name}
                            courseDescription={
                              mySectionData?.data?.courseId?.description
                            }
                            isSelfLearning={
                              mySectionData?.data?.courseId?.isSelfLearning
                            }
                            isLive={mySectionData?.data?.courseId?.isLive}
                            quizAttemptForResult={
                              quizAttemptForResult != null &&
                              quizAttemptForResult
                            }
                            quizAttempCourseId={
                              mySectionData?.data?.courseId?._id
                            }
                            coursePercentage={
                              mySectionData?.data?.progressPercent
                            }
                            pdfOpen={pdfOpen}
                            openPdfViewer={openPdfViewer}
                            videoProgress={videoProgress}
                            handleVideoProgress={handleVideoProgress}
                            item={course}
                            showEvaluationTest={showEvaluationTest}
                            setStartButtonClicked={setStartButtonClicked}
                            startButtonClicked={startButtonClicked}
                            setShowInstructions={setShowInstructions}
                            showInstructions={showInstructions}
                            showInstructionScreen={showInstructionScreen}
                            openpdf={openpdf}
                            handleClosePdf={handleClosePdf}
                            handleOpenPdf={handleOpenPdf}
                            pdfPath={pdfPath}
                            setpdfPath={setpdfPath}
                            sectionName={sectionName}
                            courseDataList={courseDataList}
                            setCourseDataList={setCourseDataList}
                            setSectionNumber={setSectionNumber}
                            setNextClick={setNextClick}
                            isDropDown={isDropDown}
                            setIsDropDown={setIsDropDown}
                            setSectionName={setSectionName}
                            sectionNumber={sectionNumber}
                            handleUpdateCourseProgress={
                              handleUpdateCourseProgress
                            }
                            selectedSubmenu={selectedSubmenu}
                            setSelectedSubmenu={setSelectedSubmenu}
                            currentSectionIndex={currentSectionIndex}
                            setCurrentSectionIndex={setCurrentSectionIndex}
                            currentDataIndex={currentDataIndex}
                            setCurrentDataIndex={setCurrentDataIndex}
                            isDropdownOpen={isDropdownOpen}
                            setIsDropdownOpen={setIsDropdownOpen}
                            setSubmittedTest={setSubmittedTest}
                            setIsPracticeQuizModal={setIsPracticeQuizModal}
                            setPracticeQuizData={setPracticeQuizData}
                            setShowCourseModalAfterQuiz={setShowCourseModalAfterQuiz}
                            setSuppressCourseModal={setSuppressCourseModal}
                      isCourseExpired={isCourseExpired}
                      neverExpired={mySectionData?.neverExpired}
                          />
                          <Box className={classes.sectionButtons}>
                            <Button
                              className={classes.sectionPrevBtn}
                              disabled={
                                currentSectionIndex <= 0 &&
                                currentDataIndex <= 0
                              }
                              variant="contained"
                              color="primary"
                              onClick={() => handlePrevClick()}
                            >
                              {t("Previous")}
                            </Button>
                            <Button
                              className={classes.sectionNextBtn}
                              disabled={
                                (isPracticeQuiz && !submittedTest) || (
                                  currentSectionIndex >= courseSectionData?.length - 1 &&
                                  currentDataIndex >=
                                  courseSectionData[currentSectionIndex]?.courseSectionData?.length - 1
                                )
                              }
                              variant="contained"
                              color="primary"
                              onClick={() => handleNextId()}
                            >
                              {t("Next")}
                            </Button>
                          </Box>
                        </CardContent>
                      </div>
                    );
                  })}
                </Card>
              ) : (
                <Box className="main-body">
                  <TabsLandingPage
                    selectedIndex={selectedTab}
                    tabBarList={tabBarList}
                    selectedTab={selectedTab}
                    mySectionData={mySectionData}
                    setMySectionData={setMySectionData}
                    handleTabChange={handleTabChange}
                    setdownloadCertificateButton={setdownloadCertificateButton}
                    onQuizCardClick={onQuizCardClick}
                    onPdfOpen={handlePdfOpen}
                    course_id={course_id}
                    subject_id={subject_id}
                    topic_id={topic_id}
                    subjectDetail={subjectDetail}
                    history={history}
                    downloadCertificateButton={downloadCertificateButton}
                    goToDashboard={goToDashboard}
                    selectedQuizCard={selectedQuizCard}
                    setActiveItem={setActiveItem}
                    activeItem={activeItem}
                    onVideoRefresh={handleVideoRefresh}
                    videoRefresh={videoRefresh}
                    sectionChanged={sectionChanged}
                    setSectionChanged={setSectionChanged}
                    courseName={mySectionData?.data?.courseId?.name}
                    courseDescription={
                      mySectionData?.data?.courseId?.description
                    }
                    isSelfLearning={
                      mySectionData?.data?.courseId?.isSelfLearning
                    }
                    isLive={mySectionData?.data?.courseId?.isLive}
                    quizAttemptForResult={
                      quizAttemptForResult != null && quizAttemptForResult
                    }
                    quizAttempCourseId={mySectionData?.data?.courseId?._id}
                    coursePercentage={mySectionData?.data?.progressPercent}
                    evaluationUnlockPercentage={
                      selectedQuizCard?.EvaluationUnlockPercent
                    }
                    pdfOpen={pdfOpen}
                    openPdfViewer={openPdfViewer}
                    videoProgress={videoProgress}
                    handleVideoProgress={handleVideoProgress}
                    showEvaluationTest={showEvaluationTest}
                    setShowEvaluationTest={setShowEvaluationTest}
                    setStartButtonClicked={setStartButtonClicked}
                    startButtonClicked={startButtonClicked}
                    setShowInstructions={setShowInstructions}
                    showInstructions={showInstructions}
                    showInstructionScreen={showInstructionScreen}
                    openpdf={openpdf}
                    handleClosePdf={handleClosePdf}
                    handleOpenPdf={handleOpenPdf}
                    pdfPath={pdfPath}
                    setpdfPath={setpdfPath}
                    sectionName={sectionName}
                    courseDataList={courseDataList}
                    setCourseDataList={setCourseDataList}
                    setSectionNumber={setSectionNumber}
                    setNextClick={setNextClick}
                    isDropDown={isDropDown}
                    setIsDropDown={setIsDropDown}
                    setSectionName={setSectionName}
                    sectionNumber={sectionNumber}
                    handleUpdateCourseProgress={handleUpdateCourseProgress}
                    selectedSubmenu={selectedSubmenu}
                    setSelectedSubmenu={setSelectedSubmenu}
                    currentSectionIndex={currentSectionIndex}
                    setCurrentSectionIndex={setCurrentSectionIndex}
                    currentDataIndex={currentDataIndex}
                    setCurrentDataIndex={setCurrentDataIndex}
                    isDropdownOpen={isDropdownOpen}
                    setIsDropdownOpen={setIsDropdownOpen}
                    setSubmittedTest={setSubmittedTest}
                    setIsPracticeQuizModal={setIsPracticeQuizModal}
                    setPracticeQuizData={setPracticeQuizData}
                    setShowCourseModalAfterQuiz={setShowCourseModalAfterQuiz}
                    setSuppressCourseModal={setSuppressCourseModal}
                      isCourseExpired={isCourseExpired}
                      neverExpired={mySectionData?.neverExpired}
                  />
                </Box>
              )}
            </Grid>
            {(!isMobile || !isVisible) && hasRendered && !showInstructions && (
              <Grid item xs={12} md={isSidebarCollapsed ? 1 : 3} style={{ display: 'flex', marginTop: !isSidebarCollapsed && showEvaluationTest ? '-16px' : "0px", overflowY: !isSidebarCollapsed && showEvaluationTest || isMobile ? 'unset' : "auto", height: !isSidebarCollapsed && showEvaluationTest || isMobile ? 'unset' : "calc(100dvh - 60px)", paddingBottom: !isSidebarCollapsed && showEvaluationTest ? 'unset' : "20px" }}>
                {isSidebarCollapsed && showEvaluationTest && <Box className={classes.rightSidebarMainDiv}>
                  <Box className={classes.rightSidebarToggleIcon}
                  onClick={handleRightSidebarOpen}>
                    <KeyboardArrowLeftSharp/>
                    <KeyboardArrowLeftSharp style={{marginLeft: '-15px'}}/>
                  </Box>
                </Box>}
                <Box className="main-right-sidebar w-full">
                  <Box
                    className={`
                      ${drawerToggle && window.innerWidth <= 959 ? classes.cardExpand : classes.card}
                      ${!isSidebarCollapsed && mySectionData?.data?.courseId?.isSelfLearning && !showEvaluationTest && !showInstructions && ''}
                      ${!isSidebarCollapsed && rightsideBarOpen && isRightSideBarButtonClicked && showEvaluationTest && !showInstructions && classes.slideInAnim}
                      ${isSidebarCollapsed && !rightsideBarOpen && isCloseButtonClicked && showEvaluationTest && !showInstructions && classes.slideOutAnim}
                    `}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      position: "sticky",
                    }}
                  >
                    {!isSidebarCollapsed && showEvaluationTest ? (
                      <Grid item xs={12}>
                        <Card>
                          <CardContent
                            style={{ padding: "0px", background: "#fafafa" }}
                          >
                            {/* Modules Section */}
                            <Paper
                              className="modules-full-box"
                              style={{
                                background: "#FFFFFF",
                                borderRadius: "10px",
                              }}
                            >
                              <Box className={classes.selfLearningBox}>
                                <Typography variant="inherit" className={classes.selfLearningText} style={{ color: `${theme?.primaryColor}` }}>
                                  {t("Self Learning")}
                                </Typography>
                                <CloseIcon onClick={handleRightSidebarClose} style={{cursor: 'pointer'}}/>
                              </Box>
                              <Box className={classes.moduleContentContainer}>
                                {mySectionData?.data?.section !== undefined ? (
                                  mySectionData?.data?.section.map(
                                    (item, index) => {
                                      return (
                                        <SelfLearningCard
                                          key={item._id || index} // Ensure unique key
                                          setActiveItem={setActiveItem}
                                          activeItem={activeItem}
                                          index={index}
                                          data={item}
                                          sectionIndex={index}
                                          sectionData={mySectionData}
                                          showEvaluationTest={
                                            showEvaluationTest
                                          }
                                          activeIndex={activeIndex}
                                          setActiveIndex={setActiveIndex}
                                          onVideoRefresh={handleVideoRefresh}
                                          courseName={mySectionData?.data?.courseId?.name}
                                          videoRefresh={videoRefresh}
                                          pdfOpen={pdfOpen}
                                          onPdfOpen={handlePdfOpen}
                                          sectionChanged={sectionChanged}
                                          openPdfViewer={openPdfViewer}
                                          setSectionChanged={setSectionChanged}
                                          nextClick={nextClick}
                                          sectionName={sectionName}
                                          onSubmenuClick={handleSubmenuClick}
                                          courseDataList={courseDataList}
                                          setCourseDataList={setCourseDataList}
                                          setSectionNumber={setSectionNumber}
                                          setNextClick={setNextClick}
                                          isDropDown={isDropDown}
                                          setIsDropDown={setIsDropDown}
                                          setSectionName={setSectionName}
                                          sectionNumber={sectionNumber}
                                          courseId={
                                            mySectionData?.data?.courseId?._id
                                          }
                                          handleUpdateCourseProgress={
                                            handleUpdateCourseProgress
                                          }
                                          setSelectedSubmenu={
                                            setSelectedSubmenu
                                          }
                                          selectedSubmenu={selectedSubmenu}
                                          currentSectionIndex={
                                            currentSectionIndex
                                          }
                                          setCurrentSectionIndex={
                                            setCurrentSectionIndex
                                          }
                                          currentDataIndex={currentDataIndex}
                                          setCurrentDataIndex={
                                            setCurrentDataIndex
                                          }
                                          isDropdownOpen={isDropdownOpen}
                                          setIsDropdownOpen={setIsDropdownOpen}
                                        />
                                      );
                                    }
                                  )
                                ) : (
                                  <></>
                                )}
                              </Box>
                            </Paper>
                          </CardContent>
                        </Card>
                      </Grid>
                    ) : (
                      mySectionData !== "" && mySectionData?.data?.courseId?.isSelfLearning && !showEvaluationTest && (
                        <CourseCard
                          courseData={mySectionData?.data?.courseId}
                          progressPercent={mySectionData?.data?.progressPercent}
                          courseId={course_id}
                          isCourseExpired={isCourseExpired}
                        />
                      )
                    )}
                    <TopicMaterialContainer
                      course_id={course_id}
                      setActiveItem={setActiveItem}
                      activeItem={activeItem}
                      mySectionData={mySectionData}
                    />
                  </Box>
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>
        {!isCourseCompletedModal && isUnlockEvaluationTestModal && 
          <EvaluationUnlockModal showModal={isUnlockEvaluationTestModal} closeModal={closeUnlockEvaluationTestModal} />
        }

        {isCourseCompletedModal && !isNoEvaluationTestModal && !settingsData?.data?.[0]?.gamification?.enabled &&
          <CourseCompletionModal showModal={isCourseCompletedModal} closeModal={closeCourseCompletedModal}/>
        }

        {!isCourseCompletedModal && isNoEvaluationTestModal && !mySectionData?.data?.evaluationTest.length > 0 &&
          <NoEvaluationTestModal showModal={isNoEvaluationTestModal} closeModal={closeNoEvaluationTestModal} />
        }

        {
          settingsData?.data?.[0]?.gamification?.enabled && isPracticeQuizModal && 
          <PracticeQuizModal showModal={isPracticeQuizModal} closeModal={closePracticeQuizModal} />
        }

        {
          settingsData?.data?.[0]?.gamification?.enabled && isCourseCompletedGamificationModal && 
          <CourseCompletionGamificationModal showModal={isCourseCompletedGamificationModal} closeModal={closeCourseCompletedGamificationModal} />
        }
      </Grid>
    </>
  );
}

export default TopicMaterial;
